import React, { useState, useEffect } from "react";
import "./ForYou.css";

// News Ticker Component

// List of your three programs
const programs = [
  {
    name: "LexTrack AI Batch 2025",
    url: "https://www.f6s.com/lextrack-ai-batch-2025"
  },
  {
    name: "LexTrack AI Batch 2025 Marketing Tech",
    url: "https://www.f6s.com/lextrack-ai-batch-2025-marketing-tech"
  },
  {
    name: "LexTrack AI Batch 2025 Sales Tech",
    url: "https://www.f6s.com/lextrack-ai-batch-2025-sales-tech"
  }
];

const ForYouPage = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const [showApplyOptions, setShowApplyOptions] = useState(false);

  const handleTalk = () => setShowCalendly(true);
  const handleClose = () => setShowCalendly(false);
  const handleApplyClick = () => setShowApplyOptions(v => !v);

  useEffect(() => {
    if (!showApplyOptions) return;
    const s = document.createElement("script");
    s.src = "https://www.f6s.com/system/js/widgets";
    s.async = true;
    document.body.appendChild(s);
    return () => document.body.removeChild(s);
  }, [showApplyOptions]);

  return (
    <div className="foryou-page">
    

      {/* START ROW */}
      <section className="foryou-start-row">
        <div className="foryou-start-container">
          <div className="foryou-start-content">
            <h1 className="foryou-start-headline">
              Accelerate your business growth<br/>
              with our venture
            </h1>
            <p className="foryou-start-subheadline">
              Lex Accelerator & Incubator connects you with investors, strategic partners, and your first customers to fundraise and expand globally. 🤖
            </p>

            <div className="foryou-start-interactive">
              <button className="foryou-cta-button" onClick={handleTalk}>
                Talk to Us
              </button>
              <span className="foryou-start-separator">Or</span>
              <button className="foryou-apply-button" onClick={handleApplyClick}>
                Apply
              </button>
            </div>

            {showApplyOptions && (
              <div className="foryou-apply-options">
                {programs.map(p => (
                  <a
                    key={p.url}
                    className="f6s-button"
                    href={p.url}
                    target="_blank"
                    rel="noopener"
                    title={`Apply to ${p.name}`}
                  >
                    {p.name}
                  </a>
                ))}
              </div>
            )}

            {showCalendly && (
              <div className="foryou-calendly-dropdown">
                <button className="foryou-close-dropdown-button" onClick={handleClose}>
                  Close
                </button>
                <iframe
                  className="foryou-calendly-embed"
                  src="https://calendly.com/het081-g/30min?embed_type=Inline"
                  frameBorder="0"
                  title="Lex Smart Connect"
                />
              </div>
            )}
          </div>

          <div className="foryou-start-visual">
            <img src="/images/logo10.jpg" alt="Secure Your Startup Growth" />
          </div>
        </div>
      </section>

      {/* BANNER ROWS */}
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner0.png" alt="Banner 0" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner1.png" alt="Banner 1" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner2.png" alt="Banner 2" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner3.png" alt="Banner 3" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner4.png" alt="Banner 4" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner5.png" alt="Banner 5" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner6.png" alt="Banner 6" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner7.png" alt="Banner 7" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner8.png" alt="Banner 8" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner9.png" alt="Banner 9" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner10.png" alt="Banner 10" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner11.png" alt="Banner 11" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner12.png" alt="Banner 12" />
      </section>

      {/* FOOTER */}
      <footer className="foryou-page-footer">
        <p>&copy; {new Date().getFullYear()} LexTrack AI. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ForYouPage;
